import React, { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  DialogContentText,
} from '@mui/material';
import { useModal } from 'components/Modals';
import { useForm } from 'react-hook-form';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { DropsContext } from 'contexts/DropsContext';
import { AuthContext } from 'contexts/AuthContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import moment from 'moment';

const DespesaModal = ({ item, reload }) => {
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({
    defaultValues: { preco: '', planoconta_id: null },
  });
  const { postLoading, postDocumentos } = useContext(DocumentosContext);
  const { drops } = useContext(DropsContext);
  const { user } = useContext(AuthContext);

  const onSubmit = ({ preco, planoconta_id }) => {
    const dt = moment().format('YYYY-MM-DD HH:mm:ss');
    const data = [
      {
        Documento: {
          especie_id: 6,
          natureza_operacao_id: 34,
          users_id: user?.id,
          filial_id: item?.filial_id,
          cadastro_id: item?.cliente_id,
          dtemissao: dt,
          conferido: 'SIM',
        },
        Entrada: { dtentrada: dt },
        Itens: [
          {
            sequencia: 1,
            descricao: `SERVIÇO REF. GARANTIA ${item?.documento || ''}`,
            quantidade: 1,
            preco,
            planoconta_id,
          },
        ],
        Financeiros: [
          { parcela: 1, dtvenc: dt, valor: preco, forma_pagto_id: 1 },
        ],
      },
      { Registros: [{ documento_id: item?.documento_id, status_id: 6 }] },
    ];

    postDocumentos({
      data,
      cb: () => {
        closeDialog();
        if (reload) reload();
      },
    });
  };

  return (
    <>
      <DialogTitle>Gerar Despesa</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DialogContentText>
              Ao gerar a despesa, a garantia será concluída.
            </DialogContentText>
          </Grid>
          <Grid item xs={12}>
            <InputMask
              name="preco"
              control={control}
              label="Valor da Despesa"
            />
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="planoconta_id"
              control={control}
              label="Plano de Contas"
              options={drops?.Planoconta?.filter(
                (p) => p?.operacional === 'SIM'
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default DespesaModal;
